import SliderInteraction, { SliderInteractionProps } from './SliderInteraction';

export type { SliderInteractionProps };
export default SliderInteraction;
